    <!-- welcome area start -->
    <div class="welcome-area pd-top-120">
        <div class="container">
            <div class="section-title">
                <h2>Welcome to your account</h2>
                <p>You are one of the <u>very first users</u> of this application!</p>
                <img src="assets/img/icon/online-learning.png" style="width:160px;margin:16px" >
                <p><b>I'm building this tool for you.</b></p><p>So contact me at <u><a href="mailto:darren@fsi-language-courses.net">darren@fsi-language-courses.net</a></u> 
                    or via the <b>chat app</b>, and request features, bug fixes or just say <i>"hi"</i>.
                </p>
                <hr>                
            </div>
            <div class="section-title">
                <h3>Available Courses</h3>
                <p><i>Currently the app only has one course - Spanish Headstart for Latin American. More courses will be available soon.</i></p>
            </div>
            <div>
                <a href="/latin-america-spanish-course">
                    <div class="item">
                        <div class="single-video-inner">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="thumb">
                                        <img src="/assets/img/course/spanish-language-course-listing.jpg" alt="img">
                                    </div>
                                </div>
                                <div class="col-md-6 align-self-center">
                                    <div class="details">
                                        <h5 style="color:#eb2100"><u>FSI Spanish Headstart for Latin America Course</u></h5>
                                        <p>DLI Course - Spanish</p>      
                                        <a class="btn btn-white log-in" href="/latin-america-spanish-course">Begin Course</a>                                  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
    <!-- welcome area end -->